import { useEffect, useState } from 'react'

import { listPrompts, markPromptUsed, type SavedPrompt } from '../lib/prompts'

const MAX_CHIPS = 5

/**
 * Bos sohbet ekraninda kayitli prompt onerileri.
 *
 * Kullanicinin HIC kayitli prompt'u yoksa satir HIC render edilmiyor -
 * uydurma "Bana bir şiir yaz" gibi ornek chip'ler YOK (bkz. planin R5
 * riski: chip'ler artik gercek kullanici verisinden geliyor).
 */
export function PromptChips({ onPick }: { onPick(body: string): void }) {
  const [prompts, setPrompts] = useState<SavedPrompt[] | null>(null)

  useEffect(() => {
    listPrompts()
      .then((items) => setPrompts(items.slice(0, MAX_CHIPS)))
      .catch(() => setPrompts([]))
  }, [])

  if (!prompts || prompts.length === 0) return null

  return (
    <div className="chip-row" role="group">
      {prompts.map((prompt) => (
        <button
          key={prompt.id}
          type="button"
          className="chip chip-prompt"
          onClick={() => {
            onPick(prompt.body)
            void markPromptUsed(prompt.id).catch(() => undefined)
          }}
        >
          {prompt.title}
        </button>
      ))}
    </div>
  )
}
